import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Home from '@mui/icons-material/Home';
import { usePages } from './PagesContext';
import PageMenu from './PageMenu';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from '../auth/AuthContext';


const useStyles = makeStyles((theme) => ({
list: {
  flexDirection: 'column',
  flexGrow: 1,
},
admin: {
  flex: 1,
  justifyContent: 'space-between'
}
}));

export default function MenuItemsList ({open}) {
 const { pages, currentPage } = usePages();
 const {currentUser} = useAuth();
 const [highlight, setHighlight] = useState(currentPage);
 const classes = useStyles();
 const pagesList = currentUser.claims.isAdmin === true ? pages : pages.filter(page => !page.pageName.match("Admin Console"));

 const handleSelectedListItem = (pageId) => {
   setHighlight(pageId);
 };

 return (
  <React.Fragment>
    {
          pagesList && pagesList.length > 0
            ? (pagesList.map((page) => (
              <PageMenu
                className={page.pageNumber === -1 ? classes.admin : null}
                page={page}
                highlight={highlight}
                handleSelectedListItem={handleSelectedListItem}
                open={open}
                key={page.pageUid}
              />
            ))
            )
            : (
              <ListItemButton
              component={Link}
              to="/">
                <ListItemIcon><Home /></ListItemIcon>
                <ListItemText primary="Home" />
              </ListItemButton>
            )
        }
  </React.Fragment>
 )
};